import {signal} from "@preact/signals-react";
import {isLoadingCommonFilters} from "@signals";

export const monitoringAdminIsEmpty = signal(false)
export const monitoringAdminReportDetails = signal({})
export const monitoringAdminReportFilters = signal({})

export const resetMonitoringAdmin = () => {
    isLoadingCommonFilters.value = false
    monitoringAdminIsEmpty.value = false
    monitoringAdminReportFilters.value = {}
    monitoringAdminReportDetails.value = {}
}